import axios from '@/utils/axios'
import {business} from '@/api/common'
import {getUrlPrefixByRole} from '@/utils/role'

/**
 * 获取所有药材
 */
export const findAllHerbs = () => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/herbs/all/find`,
    method: 'get'
  })
}

/**
 * 药材单位转换
 * @returns {*}
 */
export const getUnitConvertConfig = () => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/herbs/unitConvertConfig`,
    method: 'get'
  })
}

/**
 * 获取所有his药材
 */
export const findAllHisHerbs = (hisDeptCode = '') => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/herbs/all/his/find`,
    method: 'get',
    params: {
      hisDeptCode
    }
  })
}

/**
 * 获取所有药材克制信息
 */
export const findAllHerbsRestraint = () => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/herbs/restraint/all/find`,
    method: 'get'
  })
}

/**
 * 获取药材选项信息（单位、频次、用法）
 */
export const optionData = () => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/herbs/optionData`,
    method: 'get'
  })
}

/**
 * his配置
 */
export const hisOption = () => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/herbs/hisOption`,
    method: 'get'
  })
}

/**
 * 查询症状库
 */
export const findAllSymptoms = () => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/herbs/symptom/all/find`,
    method: 'get'
  })
}

/**
 * 查询处方项目库
 * @returns {AxiosPromise}
 */
export const allPrescriptionProject = () => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/herbs/allPrescriptionProject`,
    method: 'get'
  })
}

/**
 * 处方药材出库
 * @param recordNumber
 * @param prescriptionCodeList
 * @returns {AxiosPromise}
 */
export const takeMedicine = (recordNumber, prescriptionCodeList) => {
  return axios({
    url: `${business}${getUrlPrefixByRole()}/herbs/take/${recordNumber}`,
    method: 'post',
    headers: {
      NotNeedErrorMessage: true
    },
    data: prescriptionCodeList
  })
}



// WEBPACK FOOTER //
// ./src/api/business/doctor/herbs.js